import { ChakraText } from "components/ChakraText";
import { Modal } from "components/Modal";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  deleteReason?: string;
}

const CancellationUserAppointmentReasonModal = ({
  isOpen,
  onClose,
  deleteReason,
}: IProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader={<ChakraText>Przyczyna anulowania wizyty</ChakraText>}
    >
      {deleteReason || "Nie podano przyczyny"}
    </Modal>
  );
};

export { CancellationUserAppointmentReasonModal };
